import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgCheckSuccess = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 37.7,
	height: 25,
	viewBox: "0 0 43 29",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M40.1565 2L14.2368 27L2.45508 15.6364",
		stroke: "#2D996F",
		strokeWidth: 4,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
});
export default SvgCheckSuccess;
